import { styled } from "simplydo/react/styled";
import type { UiColor } from "simplydo/react/theme";
import { IconData } from "simplydo/react/ui/icon";
const MetaContainer = styled.div<{ $color: UiColor }>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 3px;
  height: 30px;

  background-color: ${({ theme, $color }) => theme.colors[$color].solid};
  color: ${({ theme, $color }) => theme.colors[$color].onSolid};

  > span {
    display: block;
    font-size: 12px;
  }
`;

export const MetaInfo = ({ text, color }: { text: string; color: UiColor }) => (
  <MetaContainer $color={color}>
    <span>{text}</span>
  </MetaContainer>
);
